const Environment = import.meta.env;

export default Environment;